import { createTRPCReact } from "@trpc/react-query";
import { createTRPCProxyClient, httpBatchLink } from "@trpc/client";
import type { AppRouter } from "../../../server/src/routers/_app";

export const trpc = createTRPCReact<AppRouter>();

const getBackendUrl = () => {
  if (import.meta.env.PROD) {
    return import.meta.env.VITE_BACKEND_URL || "https://api.constrigo.fr";
  }
  return import.meta.env.VITE_BACKEND_URL || "http://localhost:3001";
};

function readCsrf(): string | null {
  if (typeof document === "undefined") return null;
  const m = document.cookie.match(/(?:^|;\s*)constrigo_csrf=([^;]+)/);
  return m ? decodeURIComponent(m[1]) : null;
}

const buildHeaders = (): Record<string, string> => {
  const headers: Record<string, string> = { "x-constrigo-app": "ADMIN" };
  const csrf = readCsrf();
  if (csrf) headers["x-csrf-token"] = csrf;
  return headers;
};

const authedFetch: typeof fetch = async (input, options = {}) => {
  try {
    const response = await fetch(input, { ...options, credentials: "include" });
    if (response.status === 401) {
      localStorage.removeItem("sadmin_token");
      localStorage.removeItem("sadmin_user");
      if (typeof window !== "undefined" && !window.location.pathname.includes("/login")) {
        window.location.href = "/login";
      }
    }
    return response;
  } catch (error) {
    if (error instanceof TypeError && error.message.includes("fetch")) {
      const backendUrl = getBackendUrl();
      throw new Error(
        `Le serveur backend n'est pas accessible à l'adresse ${backendUrl}. ` +
        `Vérifiez que le backend est démarré et que la variable VITE_BACKEND_URL est correctement configurée.`
      );
    }
    throw error;
  }
};

export const trpcClient = trpc.createClient({
  links: [
    httpBatchLink({
      url: `${getBackendUrl()}/trpc`,
      headers: buildHeaders,
      fetch: authedFetch,
    }),
  ],
});

export const trpcVanilla = createTRPCProxyClient<AppRouter>({
  links: [
    httpBatchLink({
      url: `${getBackendUrl()}/trpc`,
      headers: buildHeaders,
      fetch: authedFetch,
    }),
  ],
});
